var CommunitySubscriptionEvents;
(function(CommunitySubscriptionEvents) {
    CommunitySubscriptionEvents["Success"] = 'сommunity subscription: success';
    CommunitySubscriptionEvents["Error"] = 'сommunity subscription: error';
    CommunitySubscriptionEvents["Close"] = 'common: close';
    CommunitySubscriptionEvents["Load"] = 'common: load';
})(CommunitySubscriptionEvents || (CommunitySubscriptionEvents = {}));
var CommunitySubscriptionInternalEvents;
(function(CommunitySubscriptionInternalEvents) {
    CommunitySubscriptionInternalEvents["Ready"] = 'сommunity subscription: ready';
    CommunitySubscriptionInternalEvents["Data"] = 'сommunity subscription: data';
})(CommunitySubscriptionInternalEvents || (CommunitySubscriptionInternalEvents = {}));

export { CommunitySubscriptionEvents, CommunitySubscriptionInternalEvents };
